<template>
    <li>
        <editor
            v-model="record.scratchpad"
            :live="false"
            style="height: 70vh;"
            @input="save"
        />
    </li>
</template>

<script type="text/javascript">
import tab from "../mixins/Tab"

import Editor from "../../../ui/Editor"

export default {
    mixins: [tab],
    components: {
        Editor
    },
    methods: {
        save (html) {
            this.$store.dispatch("RECORD_SAVE", {
                entity: "project",
                id: this.record.id,
                data: { scratchpad: html }
            }).catch(error => {
                this.$error(error.message)
            })
        }
    }
}
</script>
